import PathsGrid from '../components/Grid'
import { PathProvider } from '../store';

export default function PathsGridLayout() {
  return <PathProvider>
    <PathsGrid />
  </PathProvider>
}
